import { render } from "./page.vue?vue&type=template&id=6182f9a6&scoped=true"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"

import "./page.vue?vue&type=style&index=0&id=6182f9a6&scoped=true&lang=css"
import "./page.vue?vue&type=style&index=1&id=6182f9a6&lang=css"

import exportComponent from "/home/gitlab-runner/builds/NM12r8skh/0/website/official-website-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6182f9a6"]])

export default __exports__